import React, { createRef, useEffect, useRef, useState } from "react";
import Body from "../../components/Body";
import "../../styles/poRequest.scss";
import moment from "moment";
import Table from "../../common/Table";

import { AiFillPrinter } from "react-icons/ai";
import LabelText from "../../common/LabelText";
import numberFormat from "../../common/numberFormat";
import addPrecision from "../../common/addPrecision";
import removeCommas from "../../common/removeCommas";
import LetterFooter from "../../components/LetterFooter";
import LetterHeader from "../../components/LetterHeader";
import AppButton from "../../common/AppButton";
import { GiCog } from "react-icons/gi";
import { BiTrash } from "react-icons/bi";
import api from "../../config/api";
import { observer } from "mobx-react-lite";
import { cloneDeep, replace } from "lodash";
import OrganizationStore from "../../stores/OrganizationStore";
import { IoMdMail } from "react-icons/io";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { usePDF } from "react-to-pdf";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getQuotationByid } from "../../stores/QuotationStore";

const header = [
  { title: "Service Description", name: "serviceDescription" },
  { title: "Hours", name: "hours" },
  { title: "Rate", name: "rate" },
  { title: "Amount", name: "amount" },
];

function QuotationToPdf() {
  const navigate = useNavigate();
  const location = useLocation();
  const { quotation: _id } = useParams();
  const queryClient = useQueryClient();

  const { pathname } = location;

  const { data } = useQuery({
    queryFn: () => getQuotationByid({ _id }),
    queryKey: ["quotation", _id],
  });

  const handleDelete = async (quote) => {
    if (window.confirm("Are you sure want to delete the quotation ?") === false)
      return false;
    const res = await api.put("quotations", {
      _id: quote._id,
      isDeleted: true,
    });
    if (!res.ok) return toast.error(res.originalError.message);

    queryClient.invalidateQueries(["quotations"]);
    toast.success("Job has been successfully deleted");
    navigate("/quotations", { replace: true });
  };

  const { toPDF, targetRef } = usePDF({
    filename: `QUOTE - ${data?.quoteId}.pdf`,
    page: {
      format: "letter",
    },
  });

  const goHome = () => {
    navigate(String(pathname).replace("/quotationToPdf", ""));
  };

  const handleEdit = () => {
    navigate(String(pathname).replace("/quotationToPdf", "/edit"), {
      state: { data },
    });
  };

  // const noAddress =
  //   !data.invoiceAddress || String(data.invoiceAddress).includes("undefined");
  // const { findById } = new OrganizationStore();
  // const handleMail = () => {
  //   const organization = findById(data.organization);
  //   window.open(`mailto:${organization?.email}`);
  // };
  return (
    <div>
      <Helmet>
        <title>{`INV - ${data?.quoteId}`}</title>
      </Helmet>
      <Body
        onBack={goHome}
        back
        title="Quotation"
        topRight={
          <div
            className="d-flex"
            style={{ gap: "0px 0px", alignItems: "center" }}
          >
            {/* <AppButton
              onClick={handleMail}
              tooltip="Send Email"
              leftIcon={<IoMdMail size={25} />}
            /> */}
            {/* <ReactToPdf
              targetRef={printComponent}
              filename={`RPO - ${data.organizationName} - ${data.jobId}.pdf`}
            >
              {({ toPdf }) => (
                <IconButton
                  onClick={toPdf}
                  icon={<FaFileDownload size={25} />}
                />
              )}
            </ReactToPdf> */}

            <AppButton
              onClick={handleEdit}
              tooltip="Edit Quotation"
              leftIcon={<GiCog size={25} />}
            />

            <AppButton
              tooltip="Print"
              leftIcon={<AiFillPrinter size={25} />}
              onClick={() => toPDF()}
            />

            <AppButton
              onClick={() => handleDelete(data)}
              tooltip="Delete Invoice"
              leftIcon={<BiTrash size={20} />}
            />
          </div>
        }
      >
        <br />
        <br />
        <div ref={targetRef} className="po-request">
          <div style={{ padding: "1cm", paddingTop: 0 }}>
            <div>
              <LetterHeader />
              {/* <Logo /> */}
              {/* <div
                className="d-flex "
                style={{ justifyContent: "space-between" }}
              >
                <div style={{ width: 200 }}>
                  <p>
                    100 Consilium Place, Suite 200, Scarborough, Ontario <br />
                    M1H 3E3
                  </p>
                </div>
                <div>
                  <div>Tel: 647-863-5172</div>
                  <div>Fax: +1 416 439 1172</div>
                  <div>a2zcleaning786@yahoo.ca</div>
                </div>
              </div> */}
            </div>
            <div
              style={{
                // height: "3px",
                width: "100%",
                backgroundColor: "black",
                margin: "10px 0px",
                color: "white",
                fontWeight: "900",
                padding: 10,
                textAlign: "center",
                letterSpacing: 4,
              }}
            >
              QUOTATION
            </div>

            <div>
              <br />
              <div>
                <div
                  className="d-flex"
                  style={{ justifyContent: "space-between" }}
                >
                  <LabelText
                    columnMode
                    label="QUOTATION NO:"
                    value={data?.quoteId}
                  />
                </div>
              </div>
              <br />
              <br />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p>
                  Issued on :{" "}
                  {moment(data?.quotationIssueDate).format("MMMM DD, YYYY")}
                </p>
                <p>
                  Valid until :{" "}
                  {moment(data?.quotationDeadline).format("MMMM DD, YYYY")}
                </p>
              </div>

              <div>
                <div className="d-flex">
                  <p>Quotation To :</p>
                  <p
                    style={{
                      maxWidth: 400,
                      paddingLeft: 5,
                      whiteSpace: "pre-line",
                    }}
                  >
                    {data?.quotationTo}
                  </p>
                </div>
              </div>

              <div className="d-flex">
                <p>Job Date :</p>
                <p
                  style={{
                    maxWidth: 400,
                    paddingLeft: 5,
                  }}
                >
                  {moment(data?.jobStartDate).format("DD/MM/YYYY")} -
                  {" " + moment(data?.jobEndDate).format("DD/MM/YYYY")}
                </p>
              </div>

              <div className="d-flex">
                <span style={{ paddingRight: 10 }}>Job Location :</span>
                <p
                  className="text-capitalize"
                  style={{ whiteSpace: "pre-line" }}
                >
                  {!Array.isArray(data?.location) && data?.location}
                  {Array.isArray(data?.location) &&
                    data?.location?.map((i) => `${i.title}\n`)}
                </p>
              </div>
              <div>
                <br />
                <br />

                <Table
                  header={header}
                  data={data?.detailsTable?.map((i) => {
                    return {
                      ...i,
                      amount: `$ ${addPrecision(numberFormat(i.amount))}`,
                    };
                  })}
                />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div
                    style={{
                      display: "flex",
                      width: 300,
                      gap: 10,
                      flexDirection: "column",
                    }}
                  >
                    <LabelText
                      label="SUBTOTAL"
                      labelStyle={{ fontWeight: "500" }}
                      value={`$ ${addPrecision(numberFormat(data?.subtotal))}`}
                    />
                    <LabelText
                      label={`HST  (${data?.tax}%)`}
                      value={`$ ${addPrecision(
                        (Number(removeCommas(data?.subtotal)) *
                          Number(data?.tax)) /
                          100
                      )}`}
                    />
                    <LabelText
                      label="TOTAL"
                      labelStyle={{ fontWeight: "500" }}
                      value={`$ ${addPrecision(numberFormat(data?.total))}`}
                      valueStyle={{ fontWeight: "600" }}
                    />
                  </div>
                </div>
                <br />
                <br />
              </div>
              <p style={{ whiteSpace: "pre-line" }}>{data?.helpText}</p>
            </div>
          </div>
          {/* <RequestFooter /> */}
          <LetterFooter />
        </div>
      </Body>
    </div>
  );
}
export default observer(QuotationToPdf);
